export default __webpack_public_path__ + "static/media/EPIX -  Icon 2.4336ea11.png";